<template>
  <el-dropdown @command="handleCommand">
    <span class="dropdown-input">
      <span class="dropdown-label" :style="computedStyles">
        {{ label }}
        <i class="el-icon-caret-bottom el-icon--right dropdown-icon" />
      </span>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="dropItem in options" :key="dropItem.value" :command="dropItem.value">
        {{ dropItem.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
  export default {
    name: 'FormItemDropdown',
    model: {
      prop: 'command',
      event: 'change',
    },
    props: {
      labelSize:{
         type: Number,
         default: 20,
      },
      options: {
        type: Array,
        default: () => [],
      },
      command: String,
    },
 
    data() {
      return {
        form: {},
      }
    },
    computed: {
      label() {
        return this.options.find((item) => item.value === this.command)?.label
      },
       computedStyles() {
      return {
        fontSize: `${this.labelSize}px`,
      };
    }
    },
    methods: {
      handleCommand(command) {
        this.$emit('change', command)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .dropdown-label {
    // font-size: 20px;
    font-weight: 500;
    cursor: pointer;
    font-family: PingFang SC, -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Arial, Hiragino Sans GB,
      Microsoft Yahei, STHeiti, SimSun, sans-serifsans-serif;
  }
</style>
